module.exports = __webpack_public_path__ + "img/Reward_Footer.595560b2.jpg";